/**
 * Comment s'appelle un role, a l'ecran.
 *
 * 🚨 Trois cartes de libellés coexistaient le 2026-09-30, et elles ne
 * disaient pas la meme chose. Deux ecrans affichaient « Admin » et
 * « Client » en dur, un troisieme les traduisait en « Admin », « Commercial »
 * et « Lecture ». Le meme role portait donc deux noms selon l'ecran, et les
 * deux libellés en dur restaient en francais dans une interface en anglais.
 *
 * Le catalogue `admin:organisationMembers.roles.*` etait le seul complet :
 * c'est lui qui fait foi.
 */

export type RoleConnu = 'super_admin' | 'tenant_admin' | 'caller' | 'viewer';

export function roleLabels(t: (cle: string) => string): Record<RoleConnu, string> {
  return {
    super_admin: t('admin:superAdminLayout.roleLabel'),
    tenant_admin: t('admin:organisationMembers.roles.admin'),
    caller: t('admin:organisationMembers.roles.caller'),
    viewer: t('admin:organisationMembers.roles.viewer'),
  };
}

/** Le libellé d'un role, ou le role lui-meme quand il n'est pas connu. */
export function roleLabel(role: string | null | undefined, t: (cle: string) => string): string {
  if (!role) return '';
  return roleLabels(t)[role as RoleConnu] ?? role;
}
